import { useEventListener } from '@vueuse/core';

const isTextEntryElement = (element) => {
  return (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    (element instanceof HTMLElement && element.isContentEditable)
  );
};

export const useDismissKeyboardOnOutsideClick = () => {
  const dismissKeyboard = (event) => {
    const activeElement = document.activeElement;
    if (!isTextEntryElement(activeElement)) return;
    if (event.target instanceof Node && activeElement.contains(event.target)) return;

    activeElement.blur();
  };

  useEventListener(document, 'click', dismissKeyboard);
};
